
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import HeroSection from './components/HeroSection';
import MessageSection from './components/MessageSection';
import PhilosophySection from './components/PhilosophySection';
import CompanyInfoSection from './components/CompanyInfoSection';
import AccessSection from './components/AccessSection';
import CommunitySection from './components/CommunitySection';
import ContactSection from './components/ContactSection';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Breadcrumb />
      <main>
        <HeroSection />
        <MessageSection />
        <PhilosophySection />
        <CompanyInfoSection />
        <AccessSection />
        <CommunitySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
